module.exports = __webpack_public_path__ + "img/chrome6.462f8c47.png";